import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore/lite";

const firebaseConfig = {
  apiKey: "AIzaSyACCy25AmdxBPuhPtV97qFyXT-sKbOH2bk",
  authDomain: "english-5e902.firebaseapp.com",
  projectId: "english-5e902",
  storageBucket: "english-5e902.firebasestorage.app",
  messagingSenderId: "153853737490",
  appId: "1:153853737490:web:a276085596e475c537b6cb",
  measurementId: "G-KCCKELS7TV",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const analytics = getAnalytics(app);

export { auth, db, analytics }; // Fix: Export auth as a named export
